import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { renderSeparatorFieldLayoutTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-separator-field.js'

export function renderSeparatorField(field: SchemaField, indent: string): string {
  if (field.label) {
    return renderSeparatorFieldLayoutTemplate({
      indent: indent,
      fieldLabel: field.label
    })
  }
  return `${indent}<Separator className="my-4" />`
}
